import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "What's the free trial for the local business database?",
  answer: 'Every new account gets free credits to explore our local business database before committing to a paid plan. Search local business listings, view business owner emails, and launch email sequences — all at no cost. <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" class="text-blue-600 font-semibold hover:underline">Sign up for free →</a>'
}, {
  question: 'Can I see the business owner emails before paying?',
  answer: 'Yes! A major advantage of Openmart is our verified business owner emails. You can search the database, see the names and roles of the owners of local small businesses, and confirm the data exists before you spend any credits to unlock the actual email addresses.'
}, {
  question: 'How does the built-in email sequencing work?',
  answer: "Our platform includes built-in email sequencing so you don't have to export CSVs to a third-party tool. You can connect your email accounts, build multi-step email campaigns, and launch them directly to your local business database contacts from within Openmart."
}, {
  question: 'Are the local business listings verified?',
  answer: 'Absolutely. Every local business listing and business owner email you generate is verified in real-time. We check for deliverability, catch-all status, and bounce risks to ensure your built-in email sequencing campaigns maintain high sender reputation.'
}, {
  question: 'Can I export the local business database to my CRM?',
  answer: 'Yes. While we offer built-in email sequencing, you can also export your local business database directly to Salesforce, HubSpot, or download it as a CSV file for your own workflows.'
}];
export function DatabaseFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 bg-slate-50" data-id="element-2253">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2254">
        <div className="text-center mb-10" data-id="element-2255">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-2256">
            Frequently asked <span className="text-blue-600" data-id="element-2257">questions</span>
          </h2>
        </div>

        <div className="space-y-0 divide-y divide-slate-200" data-id="element-2258">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className="py-4" data-id="element-2259">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left flex justify-between items-center focus:outline-none group" aria-expanded={isOpen} data-id="element-2260">
                  <span className={`text-base font-semibold transition-colors pr-8 ${isOpen ? 'text-blue-600' : 'text-slate-900 group-hover:text-blue-600'}`} data-id="element-2261">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'transform rotate-180 text-blue-600' : 'text-slate-400 group-hover:text-blue-600'}`} data-id="element-2262" />
                </button>
                <AnimatePresence data-id="element-2263">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-2264">
                      <div className="pt-3 pb-1 text-sm text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} data-id="element-2265" />
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}